export enum EWorkflowTaskStatus {
  InProgress = 0,
  Completed = 10,
  Cancelled = 20,
  Failed = 30,
}

export enum EWorkflowStepStatus {
  Waiting = 0,
  InProgress = 10,
  WaitingForManualProcessing = 20,
  Completed = 30,
  Failed = 40,
  Skipped = 50,
}

export enum EWorkflowStepType {
  Automatic = 0,
  Manual = 1,
}

export interface IWorkflowTask {
  taskId: string;
  code: string;
  name: string;
  version: number;
  referenceType: string;
  referenceId: string;
  status: EWorkflowTaskStatus;
  startDate: string;
  completionDate?: string;
  steps: {
    stepId: string;
    code: string;
    name: string;
    sequenceNumber: number;
    type: EWorkflowStepType;
    status: EWorkflowStepStatus;
    scheduledExecutionDate?: string;
    startDate?: string;
    completionDate?: string;
    result?: string;
  }[];
}
